// extracted by mini-css-extract-plugin
export default {"Container":"Spinner_Container__8K7n4","Text":"Spinner_Text__DEW3D","Loader":"Spinner_Loader__LIS6L","load8":"Spinner_load8__NTku3"};